export const disableSaturdayAndSundays = (args) => {
    const day = args.date.getDay()
    return day === 0 || day === 6; // Zwraca true dla soboty i niedziel
}